import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { SharedModule } from '../shared.module';

import { ServicesComponent } from 'src/app/pages/services/services.component';
import { ServiceCardComponent } from 'src/app/components/utility/service-card/service-card.component';
import { ServiceListComponent } from 'src/app/components/utility/service-list/service-list.component';
import { CategoryChipsComponent } from 'src/app/components/utility/category-chips/category-chips.component';
import { ServiceStateFilterComponent } from 'src/app/components/utility/service-state-filter/service-state-filter.component';

const servicesRoutes: Routes = [{ path: '', component: ServicesComponent }];

@NgModule({
  declarations: [
    ServicesComponent,
    ServiceCardComponent,
    ServiceListComponent,
    CategoryChipsComponent,
    ServiceStateFilterComponent,
  ],
  imports: [RouterModule.forChild(servicesRoutes), CommonModule, SharedModule],
})
export class ServicesModule {}
